module.exports = __webpack_public_path__ + "static/Rahnema1-a0a2bfa88ba72317ee37680c9e21b859.jpg";